import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  Create,
  SimpleForm,
  TextInput,
  Edit,
  EditButton,
  Delete,
  Filter,
  ReferenceInput,
  SelectInput
} from 'admin-on-rest/lib/mui';

import { Actions } from '../custom/actions';

const AdminFilter = (props) => (
  <Filter {...props}>
    {/* <TextInput label="resources.name.name" source="name" alwaysOn/>
    <TextInput label="resources.surname.name" source="surname" alwaysOn/> */}
    <TextInput label="email" source="email" alwaysOn/>
  </Filter>
);

export const AdminList = (props) => (
    <List title="resources.management_admins.name" actions={<Actions />} filters={<AdminFilter />} {...props}>
        <Datagrid>
        {/* <TextField label="resources.name.name" source="name" />
        <TextField label="resources.surname.name" source="surname" /> */}
        <EmailField source="email" />
          <EditButton />
        </Datagrid>
    </List>
);

export const CreateAdmin = (props) => (
  <Create {...props}>
    <SimpleForm>
    <TextInput label="resources.name.name" source="name" />
    <TextInput label="resources.surname.name" source="surname" />
    <EmailField source="email" />
    <ReferenceInput label="resources.companies.name" source="CompanyID" reference="companies" allowEmpty>
    <SelectInput optionText={choice => `${choice.name}`} />
    </ReferenceInput>
    </SimpleForm>
  </Create>
);

const PostTitle = ({ record }) => {
    return <span>{record ? `${record.name} ${record.surname}` : ''}</span>;
};


export const EditAdmin = (props) => (
  <Edit title={<PostTitle />} {...props}>
    <SimpleForm>
    {/* <TextInput label="resources.name.name" source="name" />
    <TextInput label="resources.surname.name" source="surname" /> */}
    <TextInput source="email" type="email" />
    <ReferenceInput label="resources.companies.name" source="CompanyID" reference="companies" allowEmpty>
    <SelectInput optionText={choice => `${choice.name}`} />
    </ReferenceInput>
    </SimpleForm>
  </Edit>
);

export const DeleteAdmin = (props) => <Delete {...props} />;



// WEBPACK FOOTER //
// ./src/pages/admins.js